import { createConfigExperiment, getExperiment } from '@pegasus/abtesting';
import { useSelector } from 'react-redux';

const PROJECT_ID = 'c0823373-1914-4830-b4d6-d29209baf83b';
const NEW_CCF_IMAGES_CONTROL = 'control_old_ccf_images';
const NEW_CCF_IMAGES_VARIANT = 'variant_new_ccf_images';

export const useCCFNewImages = () => {
    // @ts-ignore
    const experiment = useSelector(state => getExperiment(state, PROJECT_ID));

    if (!experiment) {
        return false;
    }

    // @ts-ignore
    return experiment?.variant === NEW_CCF_IMAGES_VARIANT;
};

export default createConfigExperiment({
    projectId: PROJECT_ID,
    variants: [NEW_CCF_IMAGES_CONTROL, NEW_CCF_IMAGES_VARIANT],
});
